import { useI18n } from '../../../provider/i18n'
import { MdInfoOutline } from 'react-icons/md'
import { Red800 } from '../../../lib/colors'

const MaterialPreparation = () => {
  const i18n = useI18n()
  return (
    <div className="flex gap-4 bg-white border-b border-b-border border-opacity-20 p-4 rounded-lg">
      <MdInfoOutline color={Red800} size={24} />
      <p>
        <span className="text-blue-700">
          {i18n.t('screens.basket.form.preparation.header')}
        </span>
        <br />
        <span>{i18n.t('screens.basket.form.preparation.description')}</span>
      </p>
    </div>
  )
}

export default MaterialPreparation
